import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { API_PREFIX } from '@/config/env'
import { getLanguageHeader } from './i18n'

// 创建axios实例
// baseURL = '/admin-api'（统一前缀，通过 proxy/nginx rewrite 去掉）
//   - 本地: config/index.js proxyTable 匹配 /admin-api，pathRewrite 去掉前缀，转发到后端
//   - 线上: nginx location /admin-api/ rewrite 去掉前缀，转发到后端
const service = axios.create({
  baseURL: API_PREFIX,
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()
  }
  config.headers['X-Language'] = getLanguageHeader()
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  * 注意: 后端 Jackson 会把 Long 序列化为 String, 这里用 != 宽松比较兼容 "200" 和 200
  */
    const res = response.data
    if (res.code != 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code == 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js